export enum BranchState {
  actived = 'actived',
  inactived = 'inactived',
  deleted = 'deleted',
}
